import { render } from "./CargoItemRegistryModal.vue?vue&type=template&id=7261acb8"
import script from "./CargoItemRegistryModal.vue?vue&type=script&lang=js"
export * from "./CargoItemRegistryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__